import apiHelper from '@api/helper'
import store from '@store'
const state = {
  cleaning: {},
  cleaningItem: [],
  cleaningItemAttachment: [],
  cleaningIssueSearch: {},
  receiveIssueSearch: {}
}

const getters = {
  getCurrentCleaning (state) {
    return state.cleaning
  },
  getCurrentCleaningItem (state) {
    return state.cleaningItem
  },
  getCurrentCleaningItemAttachment(state) {
    return state.cleaningItemAttachment
  },
  getCleaningIssueSearch(state) {
    return state.cleaningIssueSearch
  },
  getReceiveIssueSearch(state) {
    return state.receiveIssueSearch
  },
}
// set = run after get result from backend
const actions = {
  'SET_CURRENT_CLEANING': ({commit, dispatch}, payload) => {
    commit('mutationSetCleaning', payload)
  },
  'ADD_CURRENT_CLEANING_ITEM': ({commit, dispatch}, payload) => {
    commit('mutationAddCleaningItem', payload)
  },
  'REMOVE_CURRENT_CLEANING_ITEM': ({commit, dispatch}, payload) => {
    commit('mutationRemoveCleaningItem', payload)
  },
  'UPDATE_CURRENT_CLEANING_ITEM': async ({commit, dispatch}, payload) => {
    console.error('UPDATE_CURRENT_CLEANING_ITEM',payload)
    await commit('mutationUpdateCleaningItem', payload)
  },
  'SET_CURRENT_CLEANING_ITEM': async ({commit, dispatch}, payload) => {
    commit('mutationSetCleaningItem', payload)
  },
  'SET_CURRENT_CLEANING_ITEM_ATTACHMENT': async ({commit, dispatch}, payload) => {
    commit('mutationSetCleaningItemAttachment', payload)
  },
  'ADD_CURRENT_CLEANING_ITEM_ATTACHMENT': async ({commit, dispatch}, payload) => {
    commit('mutationAddCleaningItemAttachment', payload)
  },
  'GET_CLEANING_ISSUE_SEARCH': async ({commit, dispatch}, payload) => {
    commit('mutationGetCleaningIssueSearch', payload)
  },
  'GET_RECEIVE_ISSUE_SEARCH': async ({commit, dispatch}, payload) => {
    commit('mutationGetReceiveIssueSearch', payload)
  }
}

const mutations  = {
  mutationSetCleaning (state, payload) {
    state.cleaning = payload
  },
  mutationAddCleaningItem(state, payload) {
    state.cleaningItem.push(payload)
  },
  mutationRemoveCleaningItem(state, payload) {
    let cleaningItemId = payload
    let index  = state.cleaningItem.findIndex(o => o.CleaningItemId === cleaningItemId)
    let existAttachment = state.cleaningItemAttachment
    let anyAttachment = existAttachment.some(o => o.CleaningItemId === cleaningItemId)
    if(index > -1) {
      state.cleaningItem.splice(index, 1)
    }
    if(anyAttachment) {
      state.cleaningItemAttachment = existAttachment.filter(o => o.CleaningItemId !== cleaningItemId)
    }
  },
  mutationSetCleaningItem (state, payload) {
    state.cleaningItem = payload
  },
  mutationUpdateCleaningItem(state, payload) {
    let index  = state.cleaningItem.findIndex(o => o.CleaningItemId === payload.CleaningItemId)
    if(index > -1) {
      state.cleaningItem.splice(index, 1, payload)
    }
  },
  mutationSetCleaningItemAttachment (state, payload) {
    state.cleaningItemAttachment = payload
  },
  mutationAddCleaningItemAttachment(state, payload) {
    state.cleaningItemAttachment.push(payload)
  },
  mutationGetCleaningIssueSearch (state, payload) {
    state.cleaningIssueSearch = payload
  },
  mutationGetReceiveIssueSearch (state, payload) {
    state.receiveIssueSearch = payload
  }
}

export default {
  actions, 
  getters, 
  state, 
  mutations
}
